export default __webpack_public_path__ + "static/media/chord.44ec1e66.wav";